import React, { useRef, useState, useEffect } from "react";
import { Flex, Text, Grid, GridItem, Button, Box } from "@chakra-ui/react";
import styles from "./HomePage.module.css";
import Footer from "../components/Footer";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  easeIn,
  easeOut,
  motion,
  useScroll,
  useTransform,
  AnimatePresence,
} from "framer-motion";
import Comparison from "../components/Comparison";

const headerTexts = [
  {
    title: "Kuria Bar",
    subtitle1: "1/4x Bobot Besi",
    subtitle2: "3x Lebih Kuat",
    description:
      "We are stronger, lighter, and more durable than steel. Kuria bar is corrosion resistant and low maintenance. Try the option that works for your budget.",
  },
  {
    title: "Alternatif Besi Beton",
    subtitle1: "Lebih Efektif",
    subtitle2: "Tahan Korosi",
    description:
      "Kuria Bar adalah alternatif besi beton konvensional yang dapat mengurangi resiko korosi dan lebih efektif kuat tariknya.",
  },
];

const portfolioProjects = [
  {
    id: 1,
    image: "/assets/home/portfolio-jatengland.png",
    title: "Jatengland Industrial Park Sayung",
    description: "Ruko 3 lantai, Pergudangan, Jalan Infrastruktur",
  },
  {
    id: 2,
    image: "/assets/home/portfolio-candi.png",
    title: "Kawasan Industri Candi Gatot Subroto",
    description: "Jalan Kawasan Industri",
  },
  {
    id: 3,
    image: "/assets/home/portfolio-poj.png",
    title: "Pearl of Java - Semarang",
    description: "Entertainment Center 4 Lantai",
  },
  {
    id: 4,
    image: "/assets/home/portfolio-platinum.png",
    title: "Platinum - Pekanbaru",
    description: "Proyek Development Pergudangan",
  },
];

const HomePage = () => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start start", "end end"],
  });

  // Responsive transform - more scroll on smaller screens
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 485);
    const checkTablet = () =>
      setIsTablet(window.innerWidth > 485 && window.innerWidth <= 1024);
    checkMobile();
    checkTablet();
    window.addEventListener("resize", checkMobile);
    window.addEventListener("resize", checkTablet);
    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("resize", checkTablet);
    };
  }, []);

  const x = useTransform(
    scrollYProgress,
    [0, 1],
    ["0%", isMobile ? "-180%" : isTablet ? "-175%" : "-120%"]
  );

  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % headerTexts.length);
    }, 3500);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  return (
    <Flex className={styles.container}>
      <Flex className={styles.headerSection}>
        <video
          autoPlay
          loop
          muted
          playsInline
          poster="/assets/home/main-banner.png"
          className={styles.headerVideo}
        >
          <source src="/assets/home/main-banner.webm" type="video/webm" />
          <source src="/assets/home/main-banner.mp4" type="video/mp4" />
        </video>
        <Flex className={styles.headerTextContainer}>
          <Text className={styles.headerTitleText}>
            Solusi GFRP <br /> untuk Infrastruktur Masa Depan
          </Text>
          <a href="/kuriabar">
            <Button
              className={styles.bannerButton}
              backgroundColor="#FF0000"
              color="#fff"
            >
              CARI TAHU LEBIH LANJUT
            </Button>
          </a>
        </Flex>
      </Flex>

      {/* Carousel Section */}
      <div className={styles.carouselSection} ref={targetRef}>
        <div className={styles.scrollSection}>
          <Flex flexDirection="column" alignItems="flex-start">
            <Text className={styles.carouselTitleText}>
              Merevolusi Konstruksi
            </Text>
            <Text className={styles.carouselSubTitleText}>
              dengan GFRP (Glass Fiber Reinforced Polymer)
            </Text>
          </Flex>
          <motion.div className={styles.scrollLine} style={{ x }}>
            <Flex className={styles.contentContainer}>
              <Flex className={styles.scrollBoxContainer}>
                <ScrollBox
                  icon="Frame 467.png"
                  title="Ringan"
                  text="Rebar komposit jauh lebih ringan daripada baja, sehingga mengurangi biaya transportasi dan penanganan.
"
                />
                <ScrollBox
                  icon="corrosionIcon.png"
                  title="Tahan Korosi"
                  text="Sangat tahan terhadap korosi, membuatnya ideal untuk aplikasi di lingkungan yang keras seperti daerah pesisir atau pabrik kimia."
                />
                <ScrollBox
                  icon="electricIcon.png"
                  title="Non Konduktif"
                  text="Tidak seperti baja, rebar komposit tidak menghantarkan listrik, mencegah korosi galvanik dan meminimalkan gangguan pada sistem listrik."
                />
                <ScrollBox
                  icon="thermalIcon.png"
                  title="Isolasi Termal"
                  text="Rebar komposit memiliki sifat isolasi termal yang superior, membuatnya cocok untuk aplikasi di mana kontrol suhu sangat penting.
    "
                />
              </Flex>
              <img
                className={styles.kuriaBar}
                src="/assets/home/kuriabar-black.png"
              />
              <Flex className={styles.scrollBoxContainer}>
                <ScrollBox
                  icon="fatigueIcon.png"
                  title="Ketahanan Kelelahan Baik"
                  text="Menunjukkan ketahanan kelelahan yang sangat baik, memastikan daya tahan jangka panjang dalam aplikasi yang mengalami pembebanan siklik."
                />
                <ScrollBox
                  icon="chainIcon.png"
                  title="Kekuatan Ikatan Tinggi"
                  text="Rebar komposit seringkali dapat mencapai kekuatan ikatan yang lebih baik dengan beton daripada baja, sehingga meningkatkan kinerja struktural."
                />
                <ScrollBox
                  icon="leafIcon.png"
                  title="Ramah Lingkungan"
                  text="Beberapa material rebar komposit terbuat dari bahan daur ulang, berkontribusi pada upaya keberlanjutan."
                />
                <ScrollBox
                  icon="savingIcon.png"
                  title="Hemat Biaya"
                  text="Rebar komposit dapat menawarkan penghematan biaya dalam jangka panjang karena daya tahannya dan kebutuhan pemeliharaan yang berkurang."
                />
              </Flex>
            </Flex>
          </motion.div>
        </div>
      </div>

      {/* Info Section Wrapper - contains standard section positioned at top */}
      <Flex className={styles.infoSectionWrapper}>
        <Flex className={styles.standardSection}>
          <Text className={styles.standardTitle}>Memenuhi Standar Uji</Text>
          <Flex className={styles.standardLogoContainer}>
            <img
              src="/assets/home/logo-sni.png"
              className={styles.standardLogo}
            />
            <img
              src="/assets/home/logo-sci.png"
              className={styles.standardLogo}
            />
            <img
              src="/assets/home/logo-astm.png"
              className={styles.standardLogo}
            />
            <img
              src="/assets/home/logo-iso.png"
              className={styles.standardLogo}
            />
            <img
              src="/assets/home/logo-detech.png"
              className={styles.standardLogo}
            />
          </Flex>
        </Flex>

        {/* Info Section  */}
        <Flex className={styles.infoSection}>
          <img
            src="/assets/home/kuria-fullsize.png"
            alt="Kuria Bar products"
            className={styles.infoImage}
          />
          <Flex className={styles.infoContent}>
            <Text className={styles.infoTitle}>Kuria Bar</Text>
            <Text className={styles.infoDescription}>
              Tulangan polimer yang diperkuat dengan serat kaca (GFRP rebar)
              yang dirancang untuk aplikasi beban berat. Banyak digunakan untuk
              jembatan, jalan raya serta di lingkungan yang sangat korosif
              termasuk struktur bawah air, lingkungan pantai dan situs industri.
            </Text>
            <a href="/kuriabar">
              <Button
                className={styles.infoButton}
                _hover={{
                  backgroundColor: "#fff",
                  color: "#FF0000",
                }}
              >
                LIHAT PRODUK
              </Button>
            </a>
          </Flex>
        </Flex>
      </Flex>

      {/* Wiremesh Section  */}
      <Flex className={styles.wiremeshSection}>
        <img
          src="/assets/home/wiremesh-bg.png"
          alt="Wiremesh Background"
          className={styles.wiremeshBg}
        />
        <Flex className={styles.wiremeshContent}>
          <Flex className={styles.wiremeshTextContainer}>
            <Text className={styles.wiremeshTitle}>Kuria Wiremesh</Text>
            <Text className={styles.wiremeshDescription}>
              Tulangan beton (wiremesh) yang dibuat dari batang komposit GFRP
              (Glass Fiber Reinforced Polymer), dirancang sebagai alternatif
              superior pengganti wiremesh baja konvensional.
            </Text>
            <a href="/kuriamesh">
              <Button
                className={styles.infoButton}
                backgroundColor="#FF0000"
                color="#fff"
                _hover={{
                  backgroundColor: "#fff",
                  color: "#FF0000",
                }}
              >
                LIHAT PRODUK
              </Button>
            </a>
          </Flex>
          <img
            src="/assets/home/wiremesh.png"
            alt="Wiremesh"
            className={styles.wiremeshImage}
          />
        </Flex>
      </Flex>

      {/* Application Section  */}
      {/* <Flex className={styles.applicationSection}>
        <Text className={styles.applicationHeader}>Successful Projects</Text>
        <ProjectsCarouselMobile />
        <ProjectsDesktop />
      </Flex> */}

      {/* Portfolio Section  */}
      <Flex className={styles.portfolioSection}>
        <Text className={styles.portfolioHeader}>Portfolio Proyek Kerja</Text>
        <PortfolioCarousel />
        <a href="/portfolio">
          <Button
            className={styles.portfolioViewAllButton}
            backgroundColor="#e93d27"
            color="#fff"
            _hover={{
              backgroundColor: "#c42f1e",
            }}
          >
            LIHAT SEMUA PROJEK
          </Button>
        </a>
      </Flex>

      {/* Callout Section  */}
      <Flex className={styles.callOutBanner}>
        <Flex className={styles.callOutContent}>
          <Text className={styles.callOutText}>Tertarik Pakai Kuria?</Text>
          <a
            href="https://wa.me/6285117255773"
            target="_blank"
            rel="noreferrer"
          >
            <Box as="button" className={styles.callOutButton}>
              COBA KURIA SEKARANG
            </Box>
          </a>
        </Flex>
      </Flex>

      <Footer />
    </Flex>
  );
};

export default HomePage;

function ScrollBox({ icon, title, text }) {
  return (
    <Flex className={styles.scrollBox}>
      <img className={styles.scrollIcon} src={icon} />
      <Text className={styles.scrollTitle}>{title}</Text>
      <Text className={styles.scrollText}>{text}</Text>
    </Flex>
  );
}

function ProjectsDesktop() {
  return (
    <Grid className={styles.applicationImgContainer}>
      <GridItem rowSpan={2} colSpan={1}>
        <Flex className={styles.applicationTextContainer}>
          <Text className={styles.applicationText}>
            Jatengland Industrial Park Sayung - Jawa Tengah
          </Text>
          <Text className={styles.applicationSubText}>
            Ruko 3 Lantai - Jalan Kawasan Industri
          </Text>
        </Flex>
        <img className={styles.applicationImg} src="appImg1.png" />
      </GridItem>

      <GridItem rowSpan={2} colSpan={1}>
        <img className={styles.applicationImg} src="appImg2.png" />
        <Flex className={styles.applicationTextContainer}>
          <Text className={styles.applicationText}>
            Kawasan Industri Candi Gatot Subroto - Jawa Tengah
          </Text>
          <Text className={styles.applicationSubText}>
            Jalan Kawasan Industri
          </Text>
        </Flex>
      </GridItem>
      <GridItem rowSpan={2} colSpan={1}>
        <Flex className={styles.applicationTextContainer}>
          <Text className={styles.applicationText} width="80%">
            Entertainment Center 4 Lantai
          </Text>
          <Text className={styles.applicationSubText}>
            Pearl of Java - Semarang
          </Text>
        </Flex>
        <img className={styles.applicationImg} src="appImg3.png" />
      </GridItem>
      <GridItem rowSpan={2} colSpan={1}>
        <img className={styles.applicationImg} src="appImg4.png" />
        <Flex className={styles.applicationTextContainer}>
          <Text className={styles.applicationText}>Platinum - Pekanbaru</Text>
          <Text className={styles.applicationSubText}>
            Proyek Development Pergudangan
          </Text>
        </Flex>
      </GridItem>
    </Grid>
  );
}

function ProjectsCarouselMobile() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: (dots) => (
      <ul style={{ margin: "0px", marginBottom: "48px" }}> {dots} </ul>
    ),
  };

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {/* TODO: each item here is copy pasted from ProjectsDesktop for now, but we should be able to share the code between the two */}
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText}>
              Jatengland Industrial Park Sayung - Jawa Tengah
            </Text>
            <Text className={styles.applicationSubText}>
              Ruko 3 Lantai - Jalan Kawasan Industri
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="appImg1.png" />
        </div>
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText}>
              Kawasan Industri Candi Gatot Subroto - Jawa Tengah
            </Text>
            <Text className={styles.applicationSubText}>
              Jalan Kawasan Industri
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="appImg2.png" />
        </div>
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText} width="80%">
              Entertainment Center 4 Lantai
            </Text>
            <Text className={styles.applicationSubText}>
              Pearl of Java - Semarang
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="appImg3.png" />
        </div>
        <div>
          <Flex className={styles.applicationTextContainer}>
            <Text className={styles.applicationText}>Platinum - Pekanbaru</Text>
            <Text className={styles.applicationSubText}>
              Proyek Development Pergudangan
            </Text>
          </Flex>
          <img className={styles.applicationImg} src="appImg4.png" />
        </div>
      </Slider>
    </div>
  );
}

function PortfolioArrowPrev({ onClick }) {
  return (
    <button className={styles.portfolioArrowPrev} onClick={onClick}>
      <img src="/assets/home/left.png" alt="Previous" />
    </button>
  );
}

function PortfolioArrowNext({ onClick }) {
  return (
    <button className={styles.portfolioArrowNext} onClick={onClick}>
      <img src="/assets/home/right.png" alt="Next" />
    </button>
  );
}

function PortfolioCarousel() {
  const settings = {
    centerMode: true,
    centerPadding: "20%",
    slidesToShow: 1,
    infinite: true,
    speed: 500,
    arrows: true,
    dots: false,
    prevArrow: <PortfolioArrowPrev />,
    nextArrow: <PortfolioArrowNext />,
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          centerPadding: "18%",
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerPadding: "16%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: "14%",
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: "5%",
        },
      },
    ],
  };

  return (
    <div className={styles.portfolioCarouselContainer}>
      <Slider {...settings}>
        {portfolioProjects.map((project) => (
          <div key={project.id} className={styles.portfolioSlideWrapper}>
            <div className={styles.portfolioSlide}>
              <img
                src={project.image}
                alt={project.title}
                className={styles.portfolioSlideImage}
              />
              <div className={styles.portfolioSlideOverlay}>
                <Text className={styles.portfolioSlideTitle}>
                  {project.title}
                </Text>
                <Text className={styles.portfolioSlideDescription}>
                  {project.description}
                </Text>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
